// ═══════════════════════════════════════════════════════════════
// CONFIGURAÇÃO CENTRAL — MESTRE JONAS BARCELLOS
// Para alterar o número de WhatsApp de TODO o site, mude apenas aqui.
// ═══════════════════════════════════════════════════════════════
export const WHATSAPP_NUMBER = "5521995866042";

export const WHATSAPP_MESSAGE =
  "Olá, Mestre Jonas. Gostaria de informações sobre uma consulta ou trabalho espiritual.";

export const whatsappLink = (message = WHATSAPP_MESSAGE) =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -72 });
  else el.scrollIntoView({ behavior: "smooth" });
};
